import React from "react";
import { motion } from "framer-motion";

const DiversityDrive = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 },
    },
  };

  const fadeUpVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } },
  };

  const boxVariants = {
    hidden: { opacity: 0, scale: 0.98, y: 20 },
    visible: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } },
  };

  return (
    <section className="w-full bg-[#FFFFFF] py-12 sm:py-16 md:py-20 lg:py-24 text-left relative z-10 font-sans overflow-hidden">
      <div className="max-w-[1440px] mx-auto w-full px-5 sm:px-10 lg:px-[80px] flex flex-col gap-12 sm:gap-16 md:gap-20">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          className="flex flex-col lg:flex-row justify-between gap-5 lg:gap-8 items-start w-full"
        >
          <motion.div variants={fadeUpVariants} className="lg:max-w-[427px] w-full">
            <h2 className="text-[20px] md:text-[30px] font-[600] font-sora text-[#01386A] leading-[1.3] md:leading-[1.5] tracking-tight">
              Diversity Drives Us; <br /> Inclusion Inspires Us
            </h2>
          </motion.div>
          <motion.div variants={fadeUpVariants} className="lg:max-w-[677px] w-full lg:pt-1">
            <p className="text-[14px] sm:text-[16px] text-[#49577A] leading-relaxed md:leading-[1.3] font-[500] font-graphik break-words">
              Our inclusive culture is committed to gender equality and differently-abled individuals. The recognition received by NASSCOM for 'Excellence in Diversity and Inclusion' and People Matters for the 'Best in Employer Branding' bears testimony that we prioritize talent and abilities over gender, creed, or persons with disabilities.
            </p>
          </motion.div>
        </motion.div>

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
          variants={boxVariants}
          className="group w-full bg-white border border-[#BAC9D7] border-b-4 border-b-[#01386A] p-6 sm:p-10 md:p-12 lg:p-14 flex flex-col lg:flex-row justify-between items-stretch gap-8 lg:gap-12 transition-shadow duration-300 hover:shadow-md"
        >
          <div className="lg:max-w-[588px] w-full flex flex-col justify-between flex-1 h-auto min-h-full order-2 lg:order-1">
            <h3 className="text-[20px] md:text-[30px] font-[600] text-[#01386A] font-sora mb-5 sm:mb-8 md:mb-12 leading-[1.25] tracking-tight break-words w-full max-w-[411px]">
              Diversity & Inclusion: A Cornerstone of Our Value
            </h3>

            <p className="text-[14px] md:text-[16px] text-[#49577A] font-graphik font-[500] leading-relaxed break-words w-full mt-auto lg:mt-0">
              At Cybage, the belief in creating an inclusive workspace begins at the top of its leadership and flows across every department. Founded with diversity and inclusion at its core, Cybage continues to learn, evolve, and aspire to be a place where all employees feel equal.
            </p>
          </div>
          <div className="lg:max-w-[529px] w-full shrink-0 flex justify-center lg:justify-end order-1 lg:order-2">
            <div className="max-w-[480px] lg:max-w-none aspect-[4/3] sm:aspect-[16/10] lg:aspect-[4/3] overflow-hidden relative bg-slate-100 w-full">
              <motion.img
                whileHover={{ scale: 1.03 }}
                transition={{ duration: 0.6, ease: "easeOut" }}
                src="/assets/diversity/img6.png"
                alt="Diversity and inclusion abstract green waves graphic mesh"
                className="w-full h-full object-cover absolute inset-0 transition-transform duration-500"
              />
            </div>
          </div>
        </motion.div>

      </div>
    </section>
  );
};

export default DiversityDrive;